<template>
  <div class="bg-light-warning p-8 rounded-xl flex-grow-1">
    <!--begin::Item-->
    <div class="d-flex align-items-center mb-5">
      <div class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3">
        <div class="symbol-label">
          <span class="svg-icon svg-icon-md svg-icon-danger">
            <i class="flaticon-mail text-primary"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="font-size-sm font-weight-bold">{{ value.newtrip }}</div>
        <div class="font-size-sm text-muted">New Trip</div>
      </div>
    </div>
    <!--end::Item-->
    <!--begin::Item-->
    <div class="d-flex align-items-center mb-5">
      <div class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3">
        <div class="symbol-label">
          <span class="svg-icon svg-icon-md svg-icon-info">
            <i class="flaticon2-start-up text-info"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="font-size-sm font-weight-bold">{{ value.ongoingtrip }}</div>
        <div class="font-size-sm text-muted">Ongoing Trip</div>
      </div>
    </div>
    <!--end::Item-->
    <!--begin::Item-->
    <div class="d-flex align-items-center mb-5">
      <div class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3">
        <div class="symbol-label">
          <span class="svg-icon svg-icon-md svg-icon-warning">
            <i class="flaticon2-check-mark text-success"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="font-size-sm font-weight-bold">{{ value.completedtrip }}</div>
        <div class="font-size-sm text-muted">Completed Trip</div>
      </div>
    </div>
    <!--end::Item-->
    <!--begin::Item-->
    <div class="d-flex align-items-center mb-5">
      <div class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3">
        <div class="symbol-label">
          <span class="svg-icon svg-icon-md svg-icon-success">
            <i class="flaticon2-cross text-danger"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="font-size-sm font-weight-bold">{{ value.failtrip }}</div>
        <div class="font-size-sm text-muted">Fail Trip</div>
      </div>
    </div>
    <!--end::Item-->
    <!--begin::Item-->
    <div class="d-flex align-items-center mb-5">
      <div class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3">
        <div class="symbol-label">
          <span class="svg-icon svg-icon-md svg-icon-primary">
            <i class="flaticon2-rubbish-bin text-grey"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="font-size-sm font-weight-bold">{{ value.canceltrip }}</div>
        <div class="font-size-sm text-muted">Cancelled Trip</div>
      </div>
    </div>
    <!--end::Item-->
    <!--begin::Item-->
    <div class="d-flex align-items-center">
      <div class="symbol symbol-circle symbol-white symbol-30 flex-shrink-0 mr-3">
        <div class="symbol-label">
          <span class="svg-icon svg-icon-md svg-icon-danger">
            <i class="flaticon-calendar-with-a-clock-time-tools text-dark"></i>
          </span>
        </div>
      </div>
      <div>
        <div class="font-size-sm font-weight-bold">{{ value.inactivetrip }}</div>
        <div class="font-size-sm text-muted">Inactive Trip</div>
      </div>
    </div>
    <!--end::Item-->
  </div>
</template>

<script>
export default {
  props: ["value"]
};
</script>
